import Vue from "@/main";
import store from "@/store/store.js"
import { connection } from "./jsstore_con";

export class CustomerGroupService {
    constructor() {
        this.tableName = "CustomerGroup";
        this.join = {
            with: 'CustomerGroup',
            type: 'inner',
            on: "ChatTickets.customer_id = CustomerGroup.customer_id",
            as: {
                'id': 'customerGroup.id',
                'group_id': 'customerGroup.group_id',
                'customer_id': 'customerGroup.customer_id',
                'name': 'customerGroup.name',
                'color_tag': 'customerGroup.color_tag'
            }
        }
    }

    async insert(value, refresh = false) {
        const inserted = await connection.insert({
            into: this.tableName,
            values: value,
            upsert: true
        });

        if (inserted > 0 && refresh){
            Vue.$events.fire('RefreshCountObservable');
        }
    }
    
    async update(value, refresh = false) {
        const customerId = value[0].customer_id || null;
        if ( !customerId ){ return }
        await this.remove(customerId)
        await this.insert(value, refresh)
    }

    async remove(customerId, refresh = false) {
          const removed = await connection.remove({
            from: this.tableName,
            where: { customer_id: customerId }
          });

          if (removed > 0 && refresh){
              Vue.$events.fire('RefreshCountObservable');
          }
    }
    
    async hasInFilter(customerId) {
        const groupIds = store.getters["chatContact/groupsSelectedFilter"];
        if ( !groupIds.length ){
            return true
        }

        return !!(await connection.count({
            from: this.tableName,
            where: {
                customer_id: customerId,
                group_id: { in: groupIds }
            }
        }))
    }

    async clearTable(instance) {
        let ids = [];
        let cTickets = await connection.select( {
            from: 'ChatTickets',
            where: {
                instance_id: { in: instance }
            }
        })
        
        if (cTickets.length >= 1) {
            cTickets.forEach((cTicket) => {
                ids.push(cTicket.customer_id)
            })

            await connection.remove({
                from: this.tableName,
                where: {
                    customer_id: {
                        in: ids
                    }
                }
            })
        }
    }

    getJoin(){
      return this.join
    }
}
